module.exports = __webpack_public_path__ + "img/arrow_down.34b06c9a.svg";